import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import "../CSS/Misafir_Oda.css"
import Store from '../../Store/Store'
import { set_misafir_oda } from '../../Action/Action'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import axiosInstance from '../../services/axiosConfig'

const Misafir_Oda = (props) => {

    const history = useHistory()

    const [misafir_oda, Set_misafir_oda] = useState({
        misafir: 0,
        oda: 0,
        date: ""
    })

    const [state, Set_state] = useState([])

    useEffect(() => {
        const componentDidMount = async () => {
            try {
                const req_ = await axiosInstance.post("/tags/GetMisafirOdaAll", {
                    companyId: String(props.temp_com_id)
                })

                let new_data = [];

                const response = req_.data
                console.log(response);
                new_data = response


                new_data.sort((a, b) => {
                    // Date objeleri oluştur
                    let dateA = new Date(a.date);
                    let dateB = new Date(b.date);

                    // Karşılaştırma yaparak sıralama
                    return dateA - dateB;
                });
                console.log(new_data);
                Set_state(new_data)

            } catch (error) {
                console.log(error);
            }
        }

        componentDidMount()
    }, [])

    const [alert, Set_alert] = useState({ type: "", msg: "" })

    const set_oda_misafir_func = async () => {
        const oda_sayisi = misafir_oda.oda;
        const misafir_sayisi = misafir_oda.misafir;
        let date_ = current_date;

        let date_2 = current_date;

        const date__ = new Date(date_2);
        const formattedDate = date__.toLocaleDateString("en-US");

        const now = new Date();

        let hour = now.getHours();
        let minute = now.getMinutes();
        let second = now.getSeconds();

        hour = hour < 10 ? '0' + hour : hour;
        minute = minute < 10 ? '0' + minute : minute;
        second = second < 10 ? '0' + second : second;

        var saat_str = ` ${hour}:${minute}:${second}`;

        date_ += saat_str

        console.log(date_);


        let control = 0;
        state.forEach(x => {
            if (x.date.includes(formattedDate)) {
                control++
            }
        })

        console.log(formattedDate, control, state);


        if (control < 1) {
            try {

                const req_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/InsertMisafirOda", {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify({ misafir: misafir_sayisi, oda: oda_sayisi, date: date_, companyId: String(props.temp_com_id) }),

                })

                const response = await req_.json();

                if (req_.status === 200) {
                    console.log(response);
                    await Store.dispatch(set_misafir_oda({ misafir: misafir_sayisi, oda: oda_sayisi, date: date_ }))
                    Set_alert({ type: "success", msg: "Başarıyla Kaydedildi ✓" })
                } else {
                    Set_alert({ type: "err", msg: "Bir hata oluştu." })

                }

            } catch (err) {
                console.log(err);
            }
        } else {
            window.alert("Bu tarihile kaydedilmiş bir veri zaten var!")
        }


    }

    function convertTo24HourAndDMY(dateStr) {
        // Convert the date string into a Date object
        const date = new Date(dateStr);

        // Get day, month, and year in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();

        // Get hours and minutes in 24-hour format
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the time in HH:mm:ss format
        const time24 = `${hours}:${minutes}:${seconds}`;

        // Format the date in DD/MM/YYYY format
        const formattedDate = `${day}/${month}/${year}`;

        return `${formattedDate} - ${time24}`
    }

    useEffect(() => {
        if (alert.msg !== "") {
            document.querySelector(".alert_pop_up_misafir_oda").classList.toggle("alert_pop_up_misafir_oda_active")

            setTimeout(() => {
                if (document.querySelector(".alert_pop_up_misafir_oda")) document.querySelector(".alert_pop_up_misafir_oda").classList.toggle("alert_pop_up_misafir_oda_active");
                Set_alert({ type: "", msg: "" })
            }, 4000)
        }
    }, [alert])

    const [current_date, Set_current_date] = useState("")

    const [current_date2, Set_current_date2] = useState("")



    useEffect(() => {
        try {


            let control_ = false;
            console.log(props.misafir_oda);
            if (props.misafir_oda !== undefined) {
                Set_misafir_oda(props.misafir_oda)
                let date_for_calender = props.misafir_oda.date.split(" ");
                let date_for_calender2;
                if (date_for_calender[0].includes("/")) {
                    control_ = false
                    date_for_calender2 = date_for_calender[0].split("/")
                } else if (date_for_calender[0].includes(".")) {
                    control_ = false
                    date_for_calender2 = date_for_calender[0].split(".")
                }
                else if (date_for_calender[0].includes("-")) {
                    control_ = true
                    date_for_calender2 = date_for_calender[0].split("-");
                }

                console.log(date_for_calender, date_for_calender2);
                var last_str = ""
                date_for_calender2.forEach((a, index) => {
                    if (Number(a) < 10 && a[0] !== "0") {
                        a = "0" + a;
                    }

                    if (index !== date_for_calender2.length - 1) {
                        last_str += a + "-";
                    } else {
                        last_str += a
                    }

                })

                console.log(last_str, control_);
                var last_str2 = last_str.split("-");
                console.log(last_str2);

                if (control_) {
                    last_str2 = last_str2[0] + '-' + last_str2[1] + '-' + last_str2[2];

                } else {
                    last_str2 = last_str2[2] + '-' + last_str2[0] + '-' + last_str2[1];

                }

                console.log(last_str2);

                Set_current_date(last_str2)

                last_str = last_str + " " + date_for_calender[1] + " " + date_for_calender[2]
                let new_array = date_for_calender[1].split("")

                console.log(new_array);


                if (!last_str.includes("undefined")) {
                    Set_current_date2(last_str)
                } else {
                    console.log(Number(date_for_calender[1][0] + date_for_calender[1][1]));
                    if (Number(date_for_calender[1][0] + date_for_calender[1][1]) > 12) {
                        var new_number = Number(date_for_calender[1][0] + date_for_calender[1][1])
                        new_number = new_number - 12;

                        new_number = String(new_number);
                        if (Number(new_number) < 10) {
                            new_number = "0" + new_number
                        }
                        new_array[0] = new_number[0]
                        new_array[1] = new_number[1]
                        new_array = new_array.join("")

                        var last_string_current2 = last_str2 + " " + new_array + " PM"

                        console.log(last_string_current2);

                        Set_current_date2(last_string_current2)

                    } else {
                        new_array = new_array.join("")

                        var last_string_current2 = last_str2 + " " + new_array + " AM"

                        Set_current_date2(last_string_current2)
                    }
                }

            }


        } catch (err) {
            console.log(err);
        }

    }, [props.misafir_oda])

    useEffect(() => { console.log(current_date); }, [current_date])






    return (
        <div>
            <div style={{ backgroundColor: alert.type !== "" && alert.type === "err" ? "rgb(220, 20, 60)" : "rgba(237,188,69,1)", fontSize: "large" }} className="alert_pop_up_misafir_oda">
                {alert.msg !== "" && alert.msg}
            </div>
            <section className="giris_misafir_oda">
                <div style={{
                    display: "flex",
                    "justifyContent": "space-evenly",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "6%"
                }}>
                    <div className="misafir">
                        <i className="fa-solid fa-suitcase"></i>
                        <p>Günlük Misafir sayısı <span style={{ color: "rgb(120,120,120)" }}>{`( ${convertTo24HourAndDMY(current_date2)} )`}</span></p>
                        <input onChange={(e) => {
                            Set_misafir_oda((Prev) => {
                                return { ...Prev, misafir: e.target.value }
                            })
                        }} type="number" className='misafir_inp' value={misafir_oda.misafir} />
                    </div>
                    <div className="mo_middle_gr">
                        <button disabled={current_date === null} className='misafir_btn' onClick={set_oda_misafir_func}>Kaydet</button>
                        <input type="date" id='inp_date_mi_oda' value={current_date} onChange={(e) => {
                            console.log(e.target.value);
                            Set_current_date(e.target.value)
                        }} className="input_for_calender" />
                    </div>

                    <div className="oda">
                        <i className="fa-solid fa-bed"></i>
                        <p>Günlük Oda sayısı <span style={{ color: "rgb(120,120,120)" }}>{`( ${convertTo24HourAndDMY(current_date2)} )`}</span></p>
                        <input onChange={(e) => {
                            Set_misafir_oda((Prev) => {
                                return { ...Prev, oda: e.target.value }
                            })
                        }} type="number" className='oda_inp' value={misafir_oda.oda} />
                    </div>
                </div>

                <button style={{
                    position: "relative", left: "35%", width: "25%", marginTop: "3.6%", height: "55px"
                }} onClick={() => {
                    history.push("/misaifr_oda_izleme")
                }}>Eski verileri gör <i style={{ marginLeft: "8px", fontSize: "10px", scale: "1.8", color: 'rgb(237,188,69)' }} className="fa fa-arrow-right"></i></button>




            </section >
        </div >
    )
}

const MapStateToProps = (state) => {
    return {
        misafir_oda: state.project_reducer.misafir_oda,
        temp_com_id: state.project_reducer.temp_com_id

    }
}

export default connect(MapStateToProps)(Misafir_Oda)